<template>
  <div class="content">
    <aside>
      <div class="login">
        <div class="cover">
          <img src="../assets/images/user.jpg" alt="">
        </div>
        <div class="name">Hudson</div>
      </div>
      <ul class="menu">
        <li v-for="(item,index) in router" :key="index" :class="item.path==navActive?'active':''"
            @click="changeActive(item.id,item.path)"
        >
          <span class="iconku icon" :class="item.icon"></span>
          <span class="name">{{ item.name }}</span>
        </li>
      </ul>
      <span class="title">我的音乐</span>
      <ul class="menu">
        <li v-for="(item,index) in myMusic" :key="index" :class="item.path==navActive?'active':''"
            @click="changeActive(item.id,item.path)"
        >
          <span class="iconku icon" :class="item.icon"></span>
          <span class="name">{{ item.name }}</span>
        </li>
      </ul>
      <span class="my">自建歌单
      <span>
        <span class="iconku icon ku-tianjia"></span>
        <span class="iconku icon ku-xiangxia" v-if="!showNav" @click="changeNav"></span>
        <span class="iconku icon ku-xiangshang" v-else @click="changeNav"></span>
      </span>
      </span>
      <ul class="menu" v-if="showNav">
        <li v-for="(item,index) in musicListNav" :key="index" :class="item.path==navActive?'active':''"
            @click="changeActive(item.id,item.path)"
        >
          <span class="iconku icon" :class="item.icon"></span>
          <span class="name">{{ item.name }}</span>
        </li>
      </ul>
    </aside>
    <div class="main">
      <Header></Header>
      <div class="box">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>
<script setup>
import {reactive, ref, watch} from "vue";
import {useRouter, useRoute} from "vue-router";
import Header from '@/components/Header'
const router = reactive([
  {name: '推荐', icon: 'ku-xingxing', path: 'recommend', id: 0},
  {name: '听吧', icon: 'ku-shouyinji', path: 'classifyList', id: 1},
  {name: '视频', icon: 'ku-duanshipinhuati', path: 'mvList', id: 2},
  {name: '直播', icon: 'ku-15', path: '', id: 3},
  {name: 'HiFi发烧音乐', icon: 'ku-a-5Jyinboyinpin-copy', path: '', id: 4},
])
const myMusic = reactive([
  {name: '我的【听吧】', icon: 'ku-yinliang', path: '', id: 5},
  {name: '下载管理', icon: 'ku-xiazai', path: '', id: 6},
  {name: '本地音乐', icon: 'ku-diannao_o', path: '', id: 7},
  {name: '我的云盘', icon: 'ku-yun-yunpan-yuncunchu', path: '', id: 8},
  {name: '最近播放', icon: 'ku-zuijinliulan', path: 'localMusicList', id: 9},
])
const $router = useRouter()
let $route = useRoute()
const musicListNav = reactive([
  {name: '我的收藏', icon: 'ku-jushoucang', path: 'MyFavourite', id: 10},
  {name: '默认列表', icon: 'ku-24gl-playlistMusic4', path: '', id: 11}
])
let navActive = ref()
let showNav = ref(false)
watch(() => $route.path, (newVal) => {
  let name = newVal.split('home')[1].split('/')[1]
  if (name=='playlist' ||name== 'playListDetail') {
    navActive.value = 'recommend'
    return
  }
  navActive.value = name
}, {immediate: true})
const changeActive = (index, path) => {
  if (path=='') return
  $router.push({name: path})
}
const changeNav = () => {
  showNav.value = !showNav.value
}
</script>
<style scoped lang="scss">
.content {
  width: 100%;
  height: 100%;
  //display: flex;
  aside {
    width: 200px;
    height: 100vh;
    position: fixed;
    left: 0;

    .login {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 42px;

      .cover {
        width: 40px;
        height: 40px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .name {
        font-size: 16px;
      }
    }

    .menu {
      .active {
        background-color: #ffd200 !important;
      }

      li {
        display: flex;
        align-items: center;
        padding-left: 35px;
        height: 35px;
        font-size: 14px;
        cursor: default;

        &:hover {
          background-color: #f6edc3;
        }

        .iconku {
          font-size: 18px;
        }
        .ku-24gl-playlistMusic4{
          font-size: 16px;
        }
        span {
          margin-right: 8px;
        }
      }
    }

    .title, .my {
      display: inline-block;
      padding: 15px 20px 5px 40px;
      color: #909497;
    }

    .my {
      display: flex;
      justify-content: space-between;

      .icon {
        margin: 0 5px;
        cursor: pointer;
      }
    }
  }

  .main {
    //flex: 1;
    float: right;
    width: calc(100% - 200px);
    padding-top: 50px;
    overflow: hidden;
    padding-bottom: 80px;
    .box {
      padding: 0 20px;
    }
  }
}
</style>
